import { useEffect } from "react";
import { disallowRouteEffect } from "../miscellaneous/disallowRouteEffect";
import { useCurrentPageIndex } from "./useCurrentPageIndex";
import { useLocation } from "./useLocation";
import { useNavigateToIndex } from "./useNavigateToIndex";
import { useNextPageIndex } from "./useNextPageIndex";

export function useDisallowRoute() {
  const { pathname } = useLocation();
  const indexPeekWithinGroup = useNextPageIndex({ peekWithinErrorGroup: true });
  const indexNext = useNextPageIndex();
  const navigateToIndex = useNavigateToIndex();
  const index = useCurrentPageIndex();

  useEffect(() => {
    disallowRouteEffect(
      indexPeekWithinGroup,
      indexNext,
      index,
      navigateToIndex
    );
  }, [pathname, indexPeekWithinGroup]);
}
